import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class WorkflowActionService {
  private readonly workflowActionCatalogCache = new Map<string, Observable<any>>();
  private readonly webMethodCache = new Map<string, Observable<any>>();
  private readonly outboundActionCache = new Map<string, Observable<any>>();

  constructor(private http: HttpClient) { }

  getAllActions(token, workflowID) {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    let en_URI = encodeURI(environment.apiUrl + "/workflows/" + workflowID + "/actions");
    return this.http.get<any>(en_URI, {
      headers: httpHeaders
    });
  }

  getWorkflowActionByID(token, workflowTypeID) {
    const cacheKey = `${token ?? ''}|${workflowTypeID ?? ''}`;
    const cached = this.workflowActionCatalogCache.get(cacheKey);
    if (cached) {
      return cached;
    }

    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    const request$ = this.http.get<any>(`${environment.apiUrl}/app/workflow_types/${workflowTypeID}/workflow_actions`, {
      headers: httpHeaders
    }).pipe(
      tap({ error: () => this.workflowActionCatalogCache.delete(cacheKey) }),
      shareReplay({ bufferSize: 1, refCount: false }),
    );

    this.workflowActionCatalogCache.set(cacheKey, request$);
    return request$;
  }

  getWorkFlowByID(token, workflowID) {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    // return this.http.get<any>(`${environment.apiUrl}/workflows/${workflowID}`, {
    let en_URI = encodeURI(environment.apiUrl + "/workflows/" + workflowID);
    return this.http.get<any>(en_URI, {
      headers: httpHeaders
    });
  }

  getWebMethod(token) {
    const cacheKey = String(token ?? '');
    const cached = this.webMethodCache.get(cacheKey);
    if (cached) {
      return cached;
    }

    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    const request$ = this.http.get<any>(`${environment.apiUrl}/app/workflows/web_methods`, {
      headers: httpHeaders
    }).pipe(
      tap({ error: () => this.webMethodCache.delete(cacheKey) }),
      shareReplay({ bufferSize: 1, refCount: false }),
    );

    this.webMethodCache.set(cacheKey, request$);
    return request$;
  }

  getEscalationPolicies(token) {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    return this.http.get<any>(`${environment.apiUrl}/app/escalation_policies`, {
      headers: httpHeaders
    });
  }

  getUsers(token) {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    return this.http.get<any>(`${environment.apiUrl}/app/users`, {
      headers: httpHeaders
    });
  }

  getGroups(token) {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    return this.http.get<any>(`${environment.apiUrl}/app/groups`, {
      headers: httpHeaders
    });
  }

  getOutBoundAction(token) {
    const cacheKey = String(token ?? '');
    const cached = this.outboundActionCache.get(cacheKey);
    if (cached) {
      return cached;
    }

    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    const request$ = this.http.get<any>(`${environment.apiUrl}/app/outbound_actions`, {
      headers: httpHeaders
    }).pipe(
      tap({ error: () => this.outboundActionCache.delete(cacheKey) }),
      shareReplay({ bufferSize: 1, refCount: false }),
    );

    this.outboundActionCache.set(cacheKey, request$);
    return request$;
  }

  addWorkFlowAction(token, workflowsID, params): Observable<any> {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    return this.http.post<any>(`${environment.apiUrl}/workflows/${workflowsID}/actions`, params, {
      headers: httpHeaders,
    });
  }

  updateWorkFlowAction(token, workflowsID, actionID, params): Observable<any> {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    return this.http.put<any>(`${environment.apiUrl}/workflows/${workflowsID}/actions/${actionID}`, params, {
      headers: httpHeaders,
    });
  }

  deleteWorkflowAction(token, workflowID, actionID): Observable<any> {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    return this.http.delete<any>(`${environment.apiUrl}/workflows/${workflowID}/actions/${actionID}`, {
      headers: httpHeaders,
    });
  }
  
  getAvailableEscalationPolicies(token, workflowID) {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`,
    });
    return this.http.get<any>(`${environment.apiUrl}/workflows/${workflowID}/actions/escalation_policies_available`, {
      headers: httpHeaders
    });
  }
  getAvailableResponsePlayList(token,workflowID) {
    const httpHeaders = new HttpHeaders({
      Authorization: `${token}`, 
    });
    return this.http.get<any>(`${environment.apiUrl}/workflows/${workflowID}/actions/escalation_policies_response_plays_available`, {
      headers: httpHeaders
    });
  }
}


